import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules
} from '@mui/styles';
import {Theme} from '@mui/styles';
// import {debounce} from 'lodash';
import * as request from 'superagent';
import {APIError} from '~common/lib/types';
import AutoSuggest, {AutoSuggestQuery} from '~common/components/autosuggest';
import Poptart from '~common/components/poptart';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import {without} from 'lodash';
import Renderers from '~common/lib/renderers';
import classNames from 'classnames';



const styles = (theme: Theme): StyleRules => ({
  formDefField: {
    width: '100%'
  },
  displayText: {
    marginTop: 20,
    fontSize: '1.05rem'
  },
  fieldLabel: {
    // fontSize: '0.85rem'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  value: any;
  displayValue: string;
  title: string;
  mode: string;
  error?: any;
  minQueryChars?: number;
  autoSuggestURL: string;
  onToggleChip?: () => void;
  shrink?: boolean;
  helpText: string;
  autoSuggestUrl: string;
  fieldDefinition: any;
  staticOptions?: Array<any>;
  onRelationUpdate: Function;
  excluded: Array<any>;
  appendToQuery?: Array<any>;
  // Passed to the autosuggest component for the multi-chip feature
  useChips?: boolean;
  disabled?: boolean;
  chips?: any;
}

type State = {
  //should these be here? (error and status)
  status: 'loading' | 'ready' | 'error';
  error?: any;
  originalValue: any;
  open?: boolean;
  fieldDefinition: any;
  staticOptions: any;
  value: any;
  displayValue: string;
};

class RelationField extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, props);
    let value = props.value
    
    if (props.fieldDefinition.staticOptions && props.fieldDefinition.staticOptions.length == 1) {
      value = props.fieldDefinition.staticOptions[0];
    }
    this.state = {
      fieldDefinition: props.fieldDefinition,
      value: value,
      displayValue: props.displayValue || value.label || ''
    };
  }
 componentDidMount() {
    this.probeRelationAutoSuggest()
  }

  UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
    
    const st = this.state;
    var value = newProps.value;


    if (!value) {
      value = {};
    }
    
    if (st.fieldDefinition.staticOptions && st.fieldDefinition.staticOptions.length == 1 && !st.fieldDefinition.suppressAutoSelection) {
      value = staticOptions[0];
    }
    var oldASURL = this.state.fieldDefinition.autoSuggestURL


    this.setState({
      value: value,
      displayValue: newProps.displayValue || value.label || '',
      fieldDefinition: newProps.fieldDefinition
    }, () => {
      if (oldASURL && newProps.fieldDefinition.autoSuggestURL != oldASURL) {
        
        this.probeRelationAutoSuggest()
      }
    });




  }

  probeRelationAutoSuggest = () => {
    var st = this.state;
    
    const {onRelationUpdate, autoSuggestUrl, displayValue, fieldDefinition} = this.props
    if (st.fieldDefinition.probeAutoSuggestURL) {
      let asUrl = st.fieldDefinition.autoSuggestURL
      if ( autoSuggestUrl ) {
        asUrl = autoSuggestUrl
      }
      request
        .get(asUrl)
        .then((resp) => {
          if (resp.body) {
            if (resp.body && resp.body.length > 0) {
              st.fieldDefinition.options = resp.body;
              st.fieldDefinition.autoSuggestURL = null;
              st.staticOptions = resp.body
              if (st.staticOptions && st.staticOptions.length == 1 && !st.fieldDefinition.suppressAutoSelection) {
                
                st.value = st.staticOptions[0]; 
              }

              // Report the new value upward
              
              if (onRelationUpdate) {
                onRelationUpdate(st.value);
              }
          
            }
          }
          st.status = 'ready';
          this.setState(st)
          
        })
        .catch((err) => {
          console.error(err);
        });
    }

    if (st.fieldDefinition.staticOptions && st.fieldDefinition.staticOptions.length == 1 && !st.fieldDefinition.suppressAutoSelection) {
      
      value = staticOptions[0];
    }

    
    this.setState({
      value: value,
      displayValue: displayValue || value.label || '',
      fieldDefinition: fieldDefinition
    });
  }

  appendToQuery = () => {
    var append = '';
    if (this.props.appendToQuery && this.props.appendToQuery.length > 0) {
      this.props.appendToQuery.forEach((q: any) => {
        if (q.key && q.value) {
          append += `&${q.key}=${q.value}`;
        }
      });
    }
    return append;
  };

  fetchSuggestions = (query: AutoSuggestQuery): Promise<any> => {
    const {excluded, autoSuggestUrl} = this.props;
    const {fieldDefinition} = this.state;
    var queryValid = false
    var minQueryChars = fieldDefinition.minQueryChars
    if (minQueryChars && query.value.length >= minQueryChars) {
      queryValid = true
    } else if ( !minQueryChars && query.value.length > 1){
      queryValid = true
    }
    if (queryValid) {
      
      let queryText: string = query.value.length;
      const suggestRequest = {queryText: query.value};

      let attrname = "?query="
      if(fieldDefinition.autoSuggestURL.indexOf("?")>-1){
        attrname = "&query="
      }
      let asUrl = fieldDefinition.autoSuggestURL
      if ( autoSuggestUrl ) {
        asUrl = autoSuggestUrl
      }
      var url = asUrl +
        attrname +
        query.value +
        this.appendToQuery();

      return new Promise(function (resolve, reject) {
        request
          .get(url)
          .then((response) => {
            if (response.statusCode == 200) {
              const limited = response.body.reduce((acc, item) => {
                if (!excluded || excluded.length == 0) {
                  acc.push(item);
                } else {
                  const ex = excluded.find((xItem) => {
                    return (
                      // Exsclude the item if
                      // If the excluded value matches the suggested value exactly
                      item.value == xItem.value ||
                      // If the excluded item key matches the suggested item (for string-back values like features
                      item.value == xItem.value.key ||
                      // If the suggestion has and ID and that value matches the excluded ID
                      (item.value.id && item.value.id === xItem.value.id)
                    );
                  });
                  // If not excluded, add it the the list.
                  if (!ex || ex.length == 0) {
                    acc.push(item);
                  }
                }
                return acc;
              }, []);

              resolve(limited);
            } else {
              reject(response.body);
            }
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  };

  debounceFetchSuggestions = debounce(this.fetchSuggestions, 250);

  handleSuggestionSelected = (event: any, data: any) => {
    
    
    const {onRelationUpdate, fieldDefinition} = this.props;
    if (onRelationUpdate) {
      if (
        data.suggestionValue &&
        Object.keys(data.suggestionValue).length > 0
      ) {
        var displayValue = data.suggestionValue.label
        this.setState({
          value: data.suggestionValue,
          displayValue: displayValue
        });

        data.suggestionValue.type = fieldDefinition.relationType;
        onRelationUpdate(data.suggestionValue);
      } else {
      }
    }
  };

  onSelectChange = (evt: any) => {
    const {onRelationUpdate, fieldDefinition} = this.props;
    if (onRelationUpdate && evt.target.value) {
      var newVal: any
      // This value will simply be the text, we will find the value here
      if (evt.target.value == "_nullOption" || !evt.target.value) {
        
        newVal = null
      } else {
        newVal = this.state.staticOptions.find((i) => {
        
          if (evt.target.value == i.label) {
            return true;
          }
        });
      }
      

      if (newVal) {
        let newLabel = newVal.label;

        this.setState({
          value: newVal,
          displayValue: newLabel
        });

        newVal.type = fieldDefinition.relationType;
        onRelationUpdate(newVal);
      } 
    } else {
      newVal = null
      this.setState({
        value: newVal,
        displayValue: fieldDefinition.nullOptionLabel
      });
      onRelationUpdate(newVal);
    }
  };

  render() {
    const {disabled, title, mode, helpText, error, shrink, useChips, chips, className} = this.props;
    const {fieldDefinition, value, displayValue, staticOptions} = this.state;
    const {classes}: {classes: ClassNameMap} = this.props;

    const placeholder=fieldDefinition.nullOptionLabel || "Start typing for suggestions"

    const styleObj = fieldDefinition.styleAttributes;

    
    
    // Check the registry to see if the renderer is registered, if non undefined renderer is returned, it will be used
    const suggestionRenderer:any = Renderers.find(fieldDefinition.suggestionRenderer)
    
    
    var selector = (
      <AutoSuggest
        preventBusyTab={true}
        name={fieldDefinition.autoSuggestURL}
        disabled={disabled}
        classes={{}}
        value={displayValue}
        error={error}
        onToggleChip={this.props.onToggleChip}
        chips={chips}
        useChips={useChips}
        staticOptions={staticOptions}
        placeholder={placeholder}
        minQueryChars={fieldDefinition.minQueryChars || this.props.minQueryChars || 1}
        fetchSuggestions={this.debounceFetchSuggestions}
        onSuggestionSelected={this.handleSuggestionSelected}
        displayClearAdornment={!disabled}
        suggestionRenderer={suggestionRenderer} 
        emitClear={}
      />
    );

    if (staticOptions && staticOptions.length > 0) {
      if (staticOptions.length == 1 && !fieldDefinition.suppressAutoSelection) {
        
        const c = staticOptions[0];
        const displayValue = c.label || '';
        selector = (
              <div
                className={classes.displayText}
                dangerouslySetInnerHTML={{__html: displayValue}}
              />
        );
      } else {
        const nullOptionLabel = fieldDefinition.nullOptionLabel || '';
        selector = (
          <Select
            id={fieldDefinition.key}
            name={fieldDefinition.autoSuggestURL}
            open={this.state.open}
            classes={{}}
            autoFocus={fieldDefinition.autoFocus}
            error={error}
            multiple={fieldDefinition.allowsMultiples}
            value={displayValue}
            onChange={this.onSelectChange}
            disabled={fieldDefinition.mode == 'Read Only' || disabled}
            MenuProps={{
              PaperProps: {
                style: {maxHeight: 300}
              }
            }}
            onKeyPress={(event: any) => {
              var keyPress = event.key;
              var listID: string = '';
              (staticOptions || []).map((o: any, i: number) => {
                if (
                  listID === '' &&
                  o.label.toLowerCase().charAt(0) == keyPress.toLowerCase()
                ) {
                  listID = fieldDefinition.key + '_' + i;
                  if (document.getElementById(listID) != null) {
                    const el = document.getElementById(listID);
                    if (el) {
                      el.scrollIntoView({behavior: 'smooth'});
                    }
                  }
                }
              });
              this.setState({open: true});
            }}>
            {fieldDefinition.mode != 'Required' &&
              !fieldDefinition.defaultValue && (
                <MenuItem value="">{nullOptionLabel}</MenuItem> 
              )}
            {staticOptions.map((c: any, idx: number) => {
              return (
                <MenuItem
                  id={fieldDefinition.key + '_' + idx}
                  key={idx}
                  value={c.label}>
                  {c.label}
                </MenuItem>
              );
            })}
          </Select>
        );
      }
    }

    var fieldLabel = <InputLabel
    disabled={disabled}
    error={error}
    required={fieldDefinition.mode === 'Required'}
    htmlFor="select">
    {<span>{fieldDefinition.title}{fieldDefinition.mode == "Key Field" && <i style={{color: "#CD5C5C", marginLeft: 5}} className="fa fa-key"></i>}</span>}
  </InputLabel>
    
        
    if (fieldDefinition.fieldInfo && fieldDefinition.fieldInfo.content) {
      

      fieldLabel = <InputLabel required={fieldDefinition.mode === 'Required'} shrink>{fieldDefinition.title} 
          <div style={{display: "inline-block"}}><Poptart
            click={true}
            
            placement={fieldDefinition.fieldInfo.popperPlacement || "top"}
            icon={`fa ${fieldDefinition.fieldInfo.icon || "fa-question-circle"}`}
            timeout={350}
            iconStyle={{
              display: "inline-block",
              marginLeft: 5
            }}
          >
            <div  style={{width: fieldDefinition.fieldInfo.popperWidth, padding: 5}} dangerouslySetInnerHTML={{__html: fieldDefinition.fieldInfo.content}}></div>
          </Poptart></div>
      </InputLabel>

    }

    return (
      <div>
        <FormControl
          className={classNames(classes.formDefField, className)}
          error={error ? true : false}
          style={styleObj}
          >
          {/* <InputLabel
            className={classes.fieldLabel}
            error={error}
            shrink
            required={mode == 'Required'}>
            {title}
          </InputLabel> */}
          {fieldLabel}
          {selector}
          <FormHelperText>{helpText}</FormHelperText>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(styles)(RelationField);

function debounce(f, interval) {
  let timer = null;

  return (...args) => {
    clearTimeout(timer);
    return new Promise((resolve) => {
      timer = setTimeout(() => resolve(f(...args)), interval);
    });
  };
}
